import { useCallback, useState } from "react";

import ModalMotion, {
  AnimateDirection,
} from "@/components/Molecules/ModalMotion";

import BookSlotFormWrapper from "../BookSlotFormWrapper";
import BookSlotForm from "../BookSlotForm";

import { classNameGenerator } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/BootCampReducer";

import styles from "./BookSlotModal.module.scss";

const formDefaultValue = {
  name: "",
  email: "",
  mobile: "",
  mobileCountryCode: "+91"
}
interface BookSlotModalProps {
  title: string;
  upperHeading?: string;
}

const BookSlotModal: React.FC<BookSlotModalProps> = ({ 
  title,
  upperHeading=""
 }) => {
  const dispatch = useAppDispatch();

  const [formData,setFormData] = useState(formDefaultValue)
  const cls = classNameGenerator(styles);

  const { showBookSlotModal, data } = useAppSelector((state) => state.bootCamp);
  const {modalWidth} = data?.bookSlotForm || {}

  const setShowBookSlotModal = useCallback(
    (value: any) => {
      dispatch(actions.setShowBookSlotModal(value));
    },
    [dispatch]
  );

  const { heading, upperTitle, showTnc = false } = showBookSlotModal

  return showBookSlotModal ? (
    <ModalMotion
      overlayClosable
      onClose={() => {
        setFormData(formDefaultValue)
        setShowBookSlotModal(false)
      }}
      width={modalWidth || "520px"}
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      className={cls("bookSlotModal")}
      hasTncModel={showTnc}
    >
      <BookSlotFormWrapper title={heading || title} upperTitle={upperTitle}>
        <BookSlotForm showModal={showBookSlotModal} formData={formData} setFormData={setFormData}/>
      </BookSlotFormWrapper>
    </ModalMotion>
  ) : (
    <></>
  );
};

export default BookSlotModal;
